<template>
  <v-btn
    outlined
    large
    class="mr-2"
    :disabled="!isValid"
    @click="downloadExcel"
  >
    <v-icon left>
      mdi-file-excel
    </v-icon>
    {{ $t('common.download') }}
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DownloadExcel',
  props: {
    url: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['business']),
    isValid() {
      return Array.from(Object.values(
        this.filters.filter((it) => it.required || (it.requiredForSupplier && !this.business)),
      )).every((it) => it.value);
    },
  },
  methods: {
    async downloadExcel() {
      try {
        const { data } = await this.$http.get(this.url, {
          responseType: 'blob',
          params: this.params,
        });

        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.fileName);
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },
  },
};
</script>
